module.exports = __webpack_public_path__ + "resources/icon_32_tips.a872754308549694.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_tips.png
// module id = 490
// module chunks = 0 1 2 3 4